import React from 'react';

import Typography from '@mui/material/Typography';

import { PortalFeatureFlags } from '../../services/featureFlags/portalFeatureFlags';
import { useFeatureFlagValue } from '../../services/featureFlags/useFeatureFlagValue';
import PageLayout from '../../ui/Layout';
import PaperContainer from '../../ui/Layout/PaperContainer';

export const FeatureFlagExample = (): React.ReactElement => {
  const isSampleHarnessFlagEnabled = useFeatureFlagValue(
    PortalFeatureFlags.sampleHarnessFlag,
    false
  );

  return (
    <PageLayout title="Feature flag example" documentTitle="Feature flag example">
      <PaperContainer>
        <Typography>
          The sample Harness feature flag is {isSampleHarnessFlagEnabled ? 'enabled' : 'disabled'}.
        </Typography>
      </PaperContainer>
    </PageLayout>
  );
};

export default FeatureFlagExample;
